import script from "./FormLocationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLocationComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormLocationComponent.vue?vue&type=style&index=0&id=9d01a59e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d01a59e"]])

export default __exports__